import { AuthenticateMessagePayload } from 'embedded/api/in/messages/AuthenticateMessagePayload';

export type ContextWithToken = AuthenticateMessagePayload;

export function isContextWithToken(token: unknown): token is ContextWithToken {
    const asContextWithToken = token as ContextWithToken;
    return (
        asContextWithToken &&
        !!asContextWithToken.token &&
        !!asContextWithToken.application &&
        !!asContextWithToken.applicationVersion
    );
}
